/**
 *  @class
 *  @function PromotionBarSlider
 *  Auto-advances the promotion bar items and handles prev/next arrows.
 */
if (!customElements.get('promotion-bar-slider')) {
  class PromotionBarSlider extends HTMLElement {
    connectedCallback() {
      this.inner = this.querySelector('.promotion-bar--inner');
      if (!this.inner) return;

      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = parseInt(this.dataset.interval, 10) || 4000;
      this.paused = false;
      this._resumeTimeout = null;

      // Arrows
      this.prevBtn = this.querySelector('.promotion-bar--arrow-prev');
      this.nextBtn = this.querySelector('.promotion-bar--arrow-next');
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.navigate(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.navigate(1));

      // Show arrows only when there is something to scroll
      this.checkOverflow = this.checkOverflow.bind(this);
      this.checkOverflow();
      window.addEventListener('resize', this.checkOverflow);

      // Pause while the customer hovers or touches the bar
      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });
      this.addEventListener('touchstart', () => {
        this.paused = true;
        clearTimeout(this._resumeTimeout);
      }, { passive: true });
      this.addEventListener('touchend', () => this.resumeSoon(), { passive: true });

      if (this.autoplay) {
        this._timer = setInterval(() => this.tick(), this.interval);
      }
    }
    disconnectedCallback() {
      clearInterval(this._timer);
      clearTimeout(this._resumeTimeout);
      window.removeEventListener('resize', this.checkOverflow);
    }
    checkOverflow() {
      this.classList.toggle('has-overflow', this.inner.scrollWidth > this.inner.clientWidth + 10);
    }
    resumeSoon() {
      clearTimeout(this._resumeTimeout);
      this._resumeTimeout = setTimeout(() => { this.paused = false; }, 5000);
    }
    step() {
      const item = this.inner.querySelector('.promotion-bar--item');
      return item ? item.offsetWidth + 30 : this.inner.clientWidth;
    }
    navigate(direction) {
      const inner = this.inner;
      const maxScroll = inner.scrollWidth - inner.clientWidth;
      let next = inner.scrollLeft + direction * this.step();
      if (next < -5) next = maxScroll;
      if (next > maxScroll + 5) next = 0;
      inner.scrollTo({ left: Math.max(0, Math.min(next, maxScroll)), behavior: 'smooth' });
      this.paused = true;
      this.resumeSoon();
    }
    tick() {
      if (this.paused || document.hidden) return;
      const inner = this.inner;
      if (inner.scrollWidth <= inner.clientWidth + 10) return;
      const maxScroll = inner.scrollWidth - inner.clientWidth;
      let next;
      if (inner.scrollLeft >= maxScroll - 10) {
        next = 0;
      } else {
        next = Math.min(inner.scrollLeft + this.step(), maxScroll);
      }
      inner.scrollTo({ left: next, behavior: 'smooth' });
    }
  }
  customElements.define('promotion-bar-slider', PromotionBarSlider);
}
